import { useParams } from "react-router-dom";
import Layout from "./Layout";
import AddToCartButton from "./AddToCartButton";
import { useState, useEffect } from "react";
import { getProductById, requestRestockApi } from "../services/api";
import ImageGallery from "react-image-gallery";
import "react-image-gallery/styles/css/image-gallery.css";
import "../styles/style.css";

export default function ProductDetail() {
  //const { state } = useLocation();
  const { id } = useParams();
  const [product, setProduct] = useState(null);
  const [loading, setLoading] = useState(false);
  //const [product, setProduct] = useState(state?.product || null);
  //const [loading, setLoading] = useState(!state?.product);
  const [restockLoading, setRestockLoading] = useState(false);
  const [restockRequested, setRestockRequested] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
    if (!product) {
      getProductById(id).then((data) => {
        setProduct(data);
        setLoading(false);
      });
    }
  }, [id]);

  if (!product) {
    return (
      <Layout>
        <div className="text-center py-20 text-gray-400">
          Loading product...
        </div>
      </Layout>
    );
  }

  const galleryImages = product.image?.map((img) => ({
    original: img,
    thumbnail: img,
  }));

  const handleRequestRestock = async () => {
    if (!product || restockLoading) return;

    try {
      setRestockLoading(true);

      await requestRestockApi({
        productId: product._id || product.id,
        productName: product.name,
        productImage: product.image?.[0] || "",
        productPrice: product.price,
      });

      setRestockRequested(true);
    } catch (error) {
      console.error("Restock request error:", error);

      alert(
        error?.response?.data?.message ||
          "Unable to send restock request. Please try again.",
      );
    } finally {
      setRestockLoading(false);
    }
  };

  const isOutOfStock = product.qty === 0;

  return (
    <Layout>
      <section className="px-6 py-6 mx-auto grid grid-cols-1 md:grid-cols-2 gap-8">
        {/* Product Image */}
        <div>
          {/* <img
            src={product.image}
            alt={product.name}
            className="w-full h-auto object-cover rounded-lg shadow-lg"
          /> */}
          <ImageGallery
            items={galleryImages}
            showThumbnails={product.image.length > 1 ? true : false}
            showPlayButton={false}
            showFullscreenButton={false}
            slideInterval={3000}
          />
        </div>

        {/* Product Details */}
        <div className="flex flex-col ">
          <div>
            <h1 className="text-4xl font-serif text-light_primary mb-4">
              {product.name}
            </h1>
            {product?.categoryId === "69dc8fcfdd2bdcff6f2c478b" ? (
              ""
            ) : (
              <p className="text-hover_light_primary text-2xl font-medium mb-4">
                Rs. {product.price}
              </p>
            )}
            {product.description ? (
              <div className="text-black">
                <h3 className="text-xl font-semibold mb-2">Description</h3>
                <p className="mb-4 ">{product.description}</p>{" "}
              </div>
            ) : (
              ""
            )}

            {product.dimensions ? (
              <div className="text-black">
                <h3 className="text-xl font-semibold mb-2">Dimensions</h3>
                <p className="mb-4 ">{product.dimensions}</p>
              </div>
            ) : (
              ""
            )}
          </div>

          {product?.categoryId === "69dc8fcfdd2bdcff6f2c478b" ? (
            <button
              className={`px-4 py-2 rounded transition text-white w-fit
              ${
                product.qty === 0
                  ? "bg-gray-500 cursor-not-allowed"
                  : "bg-light_primary hover:bg-hover_light_primary"
              }`}
            >
              Contact for Price
            </button>
          ) : (
            <AddToCartButton product={product} />
          )}

          {isOutOfStock ? (
            <button
              type="button"
              onClick={handleRequestRestock}
              disabled={restockLoading || restockRequested}
              className={`mt-2 px-2 py-2 rounded transition text-white w-fit ${
                restockRequested
                  ? "bg-green-600 cursor-default"
                  : restockLoading
                    ? "bg-gray-500 cursor-not-allowed"
                    : "bg-light_primary hover:bg-hover_light_primary"
              }`}
            >
              {restockRequested
                ? "Restock Request Sent"
                : restockLoading
                  ? "Sending Request..."
                  : "Request to Restock"}
            </button>
          ) : (
            ""
          )}

          <div className="text-black mt-5 text-xl font-semibold">
            For bulk order Contact us on :
            <a
              href="tel:+919825081632"
              className="text-primary hover:underline ml-2"
            >
              (+91) 9825081632
            </a>
          </div>
        </div>
      </section>
    </Layout>
  );
}
